<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex flex-row-reverse" cols="12">
        <ButtonComp @click="showDeleteItems" textButton="Eliminar" classColor="red" normalButton
          iconBut="fa fa-trash-alt" />
        <ButtonComp @click="addItem" textButton="Agregar" class-button="mx-2" normalButton icon-but="fas fa-plus" />
      </v-col>
      <v-col cols="12">
        <ComundataTablecomp :headers="ProvisionesTesoreriaHeaders" :items="listItems" :search="search"
          item-key="id_asig_provision_detalle" v-model="selectedItems" :loading="loading" whitSelect whitSearch>
          <template v-slot>
            <v-col cols="12" md="3" sm="3" class="py-0">
              <v-autocomplete label="Año" v-model="filtro.id_anio" :items="lista_filtro_anios" item-value="id"
                item-text="nom_anolectivo" @change="changeFiltroAnio(filtro.id_anio)" autocomplete="off">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="3" sm="3" class="py-0">
              <v-autocomplete label="Moneda" v-model="filtro.id_moneda" :items="lista_filtro_monedas"
                item-value="id_moneda" item-text="nombre_moneda" @change="changeFiltroMoneda(filtro.id_moneda)"
                autocomplete="off">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="2" sm="2" class="py-0">
              <v-autocomplete label="Nivel" v-model="filtro.id_nivel" :items="lista_filtro_niveles" item-value="id"
                item-text="desc_nivel" @change="changeFiltroNivel(filtro.id_nivel)" autocomplete="off">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="2" sm="2" class="py-0">
              <v-autocomplete label="Grado" v-model="filtro.id_grado" :items="lista_filtro_grados" item-value="id"
                item-text="desc_grado" @change="changeFiltroGrado()" autocomplete="off">
              </v-autocomplete>
            </v-col>
          </template>
          <template v-slot:nom_anolectivo="{ item }">{{ item.nom_anolectivo }}</template>
          <template v-slot:concepto="{ item }">{{ item.concepto }}</template>
          <template v-slot:desc_nivel="{ item }">{{ item.desc_nivel }}</template>
          <template v-slot:desc_grado="{ item }">{{ item.desc_grado }}</template>
          <template v-slot:desc_turno="{ item }">{{ item.desc_turno }}</template>
          <template v-slot:nombre_moneda="{ item }">{{ item.nombre_moneda }}</template>
          <template v-slot:monto="{ item }">{{ item.monto }}</template>

          <template v-slot:action_generar="{ item }">
            <ButtonComp v-if="componenteEvento.editar_submodulo && item.estado != 'GENERADO'"
              @click="showGenerate(item.id_asig_provision)" textButton="Generar cobro" />

            <span v-if="item.estado == 'GENERADO'">{{ item.estado }}</span>
          </template>
          <template v-slot:action_editar="{ item }">
            <ButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
              tooltipText="Editar provision" />

          </template>
        </ComundataTablecomp>
      </v-col>
    </v-row>

    <!-- consultar -->


    <!-- Modal -->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="showDialog" max-width="900px" :title="formTitle" @close-modal="showDialog = false">
        <template v-slot:body>
          <v-row>

            <v-col cols="12" sm="5" md="5">
              <v-card>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" sm="12" md="6">
                      <AutocompleteComp text-label="Año" v-model="editedItem.id_anio" :items="listaAniosModal"
                        @change="changeAnio(editedItem.id_anio)" item-value="id" item-text="nom_anolectivo"
                        :rules="validationRules.validateCampoList" />
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                      <AutocompleteComp text-label="Nivel" v-model="editedItem.id_nivel" :items="lista_niveles"
                        @change="changeNivel(editedItem.id_nivel)" item-value="id" item-text="desc_nivel"
                        :rules="validationRules.validateCampoList" />

                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                      <AutocompleteComp text-label="Grado" v-model="editedItem.id_grado" :items="lista_grados"
                        @change="changeGrado(editedItem.id_anio, editedItem.id_nivel, editedItem.id_grado)"
                        item-value="id" item-text="desc_grado" :rules="validationRules.validateCampoList" />
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                      <AutocompleteComp text-label="Sección" v-model="editedItem.id_seccion" :items="lista_secciones"
                        @change="changeSeccion(editedItem.id_anio, editedItem.id_seccion)" item-value="id"
                        item-text="nombre_seccion" :rules="validationRules.validateCampoList" />
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                      <AutocompleteComp text-label="Turno" v-model="editedItem.id_turno" :items="listaTurnosModal"
                        item-value="id" item-text="desc_turno" />
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                      <AutocompleteComp text-label="Estudiante" v-model="editedItem.id_estudiante"
                        :items="lista_estudiantes" item-value="id" item-text="nombre_estudiante" />
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                      <AutocompleteComp text-label="Moneda" v-model="editedItem.id_moneda" :items="listaMonedasModal"
                        item-value="id_moneda" item-text="nombre_moneda" :rules="validationRules.validateCampoList" />
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                      <textfieldComp text-label="Monto" type="number" v-model="editedItem.monto"
                        :rules="validationRules.validateCampo" />

                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <TextfieldComp textArea text-label="Concepto" type="text" v-model="editedItem.concepto"
                        :rules="[rul.required, rul.max30]">
                      </TextfieldComp>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

            </v-col>
            <v-col cols="12" sm="7" md="7">
              <v-card>
                <v-card-text>
                  <v-data-table :headers="ProvisionesDetHeaders" :items="listItemsDetail" :items-per-page="12"
                    :hide-default-footer="true" fixed-header item-key="id_mes" v-model="selectedItemDetails" show-select
                    unselectable :loading="loadingDetail">
                    <template v-slot:[`header.data-table-select`]="{ on, props }">
                      <v-simple-checkbox v-bind="props" v-on="on" class="text-center"></v-simple-checkbox>
                    </template>
                    <template v-slot:item.fecha_generado="{ item }">
                      <v-edit-dialog :return-value.sync="item.fecha_generado" @save="save" @cancel="cancel" @open="open"
                        @close="close" large> {{ item.fecha_generado | filtroFecha }}
                        <template v-slot:input>
                          <v-date-picker v-model="item.fecha_generado" :min="item.fecha_min" :max="item.fecha_max"
                            :show-current="false" no-title>
                          </v-date-picker>
                        </template>
                      </v-edit-dialog>
                    </template>
                    <template v-slot:item.fecha_vencimiento="{ item }">
                      <v-edit-dialog :return-value.sync="item.fecha_vencimiento" @save="save" @cancel="cancel"
                        @open="open" @close="close" large> {{ item.fecha_vencimiento | filtroFecha }}
                        <template v-slot:input>
                          <v-date-picker v-model="item.fecha_vencimiento" :min="item.fecha_min" :max="item.fecha_max"
                            :show-current="false" no-title>
                          </v-date-picker>
                        </template>
                      </v-edit-dialog>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <!-- <v-btn
              :style="{color: '#ffffff'}"
              class="btn_block_style5"
              
              :disabled="editedItem.estado == 'GENERADO'"
              @click="showGenerate(editedItem.id_asig_provision)"
              >Generar Cobros</v-btn
            > -->
          <ButtonComp :disabled="btnIsSaving || editedItem.estado == 'GENERADO'"
            @click="saveItem(editedItem ? editedItem.id_asig_provision : 0)"
            :textButton="isNew ? 'Guardar' : 'Guardar Cambios'" normal-button iconBut="fas fa-save" />
          <ButtonComp text-button="Cancelar" @click="showDialog = false" classColor="red" normal-button
            classButton="mx-2" />

        </template>
      </ComunDialogComp>

    </v-form>

    <confirm titleWindow="Eliminar registro" @aceptar="deleteItems" @cancelar="cancelDelete" :title="confirm.title"
      :active="confirm.active" />
    <confirm titleWindow="Generar cobro" @aceptar="generateProvision(confirmGenerate.id)" @cancelar="cancelGenerate"
      :title="confirmGenerate.title" :active="confirmGenerate.active" />
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import CommonRules from "../../commonRules";
import { mapMutations, mapGetters, mapActions } from "vuex";
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";
import { ProvisionesTesoreriaHeaders, ProvisionesDetHeaders } from '../../../../helpers/headersTable';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import { validationRules } from "../../../../helpers/validatorHelpers";
import TextfieldComp from '../../../../components/ComponentsEst/textfieldComp.vue';

export default {
  components: {
    AutocompleteComp,
    ComundataTablecomp,
    ButtonComp,
    ComunDialogComp,
    TextfieldComp,
  },
  data: () => ({
    paramComponente: { id_submodulo: 2, id_modulo: 4 },
    dataSession: sessionStorage,
    ProvisionesTesoreriaHeaders,
    ProvisionesDetHeaders,
    selectedItems: [],
    selectedItemDetails: [],
    showDialog: false,
    btnIsSaving: false,
    loading: false,
    loadingDetail: false,
    search: "",
    filtro: {
      id_anio: null,
      id_moneda: null,
      id_nivel: null,
      id_grado: null
    },
    confirm: {
      id: 0,
      title: "",
      active: false,
    },
    confirmGenerate: {
      id: 0,
      title: "",
      active: false,
    },


    rul: CommonRules(),
    listItems: [],
    listItemsDetail: [],
    lista_anios: [],
    lista_niveles: [],
    lista_grados: [],
    lista_secciones: [],
    lista_estudiantes: [],
    lista_turnos: [],
    lista_monedas: [],
    lista_filtro_anios: [],
    lista_filtro_monedas: [],
    lista_filtro_niveles: [],
    lista_filtro_grados: [],
    isNew: true,
    editedItem: { detalle: [] },
  }),

  computed: {

    validationRules() {
      return validationRules
    },

    formTitle() {
      return this.isNew ? "Registro de provisiones" : "Editar registro de provisiones";
    },
    listaAniosModal() {
      return this.lista_anios;
    },
    listaTurnosModal() {
      return this.lista_turnos;
    },
    listaMonedasModal() {
      return this.lista_monedas;
    },
    filtroFechaGeneradoFormatted() {
      return this.formatDate(this.editedItem.fecha_generado);
    },

    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.getListaAsigProvisions();
    this.getListaAniosFiltro();
    this.getListaMonedasFiltro();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    async showDeleteItems() {
      if (this.selectedItems.length > 0) {
        this.confirm.id = 0;
        this.confirm.title = "¿Está seguro de borrar los registros seleccionados?";
        this.confirm.active = true;
      }
    },

    async showGenerate(id) {
      this.confirmGenerate.id = id;
      this.confirmGenerate.title = "¿Está seguro de generar los cobros? Esta operación no es reversible";
      this.confirmGenerate.active = true;
    },

    save() { },
    cancel() { },
    open() { },
    close() { },
    //https://vuetify.cn/en/components/date-pickers/

    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    cancelDelete() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },

    cancelGenerate() {
      this.confirmGenerate.id = 0;
      this.confirmGenerate.title = "";
      this.confirmGenerate.active = false;
    },

    async limpiarForm() {
      this.selectedItemDetails = [];
      this.editedItem = {
        id_anio: null,
        id_nivel: null,
        id_grado: null,
        id_seccion: null,
        id_turno: null,
        id_estudiante: null,
        id_moneda: null,
        monto: null,
        concepto: '',
        detalle: []
      };
      this.$refs.formDatos.resetValidation();
    },

    async changeAnio(id) {
      await this.getListaNiveles(id);
    },

    async changeNivel(id) {
      await this.getListaGrados(id);
    },

    async changeGrado(id_anio, id_nivel, id_grado) {
      await this.getListaSecciones(id_anio, id_nivel, id_grado);
    },

    async changeSeccion(id_anio, id_seccion) {
      await this.getListaEstudiantes(id_anio, id_seccion);
    },

    async changeFiltroAnio(id) {
      await this.getListaNivelesFiltro(id);
      await this.getListaAsigProvisions();
    },

    async changeFiltroMoneda() {
      await this.getListaAsigProvisions();
    },

    async changeFiltroNivel(id) {
      await this.getListaGradosFiltro(id);
      await this.getListaAsigProvisions();
    },

    async changeFiltroGrado() {
      await this.getListaAsigProvisions();
    },

    //----------- AREGAR REGISTROS  --------------
    async addItem() {
      this.btnIsSaving = false;
      this.isNew = true;
      this.limpiarForm();
      await this.getListaAnios();
      await this.getListaTurnos();
      await this.getListaMonedas();
      await this.getAsigProvisionDetalleByIdParent(0);
      this.showDialog = true;
    },

    //--------------EDITAR REGISTRO--------------
    async editItem(item) {
      console.log('editItem', item);
      this.btnIsSaving = false;
      this.isNew = false;
      this.selectedItemDetails = [];
      await this.getListaAnios();
      await this.getListaNiveles(item.id_anio);
      await this.getListaGrados(item.id_nivel);
      await this.getListaSecciones(item.id_anio, item.id_nivel, item.id_grado);
      await this.getListaTurnos();
      await this.getListaEstudiantes(item.id_anio, item.id_seccion);
      await this.getListaMonedas();
      await this.getAsigProvisionById(item.id_asig_provision);
      await this.getAsigProvisionDetalleByIdParent(item.id_asig_provision);
      this.showDialog = true;
    },

    /// FILTROS
    getListaAniosFiltro() {
      axios
        .get("/administrativo/anoLectivo/estado/" + this.dataSession.id_colegio)
        .then((response) => {
          this.lista_filtro_anios = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaMonedasFiltro() {
      axios
        .get("/tesoreria/common/moneda")
        .then((response) => {
          this.lista_filtro_monedas = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaNivelesFiltro(id_anio) {
      this.lista_filtro_niveles = [];
      this.filtro.id_nivel = null;
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: id_anio,
      };

      axios
        .post("/tesoreria/common/nivel", params)
        .then((response) => {
          this.lista_filtro_niveles = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaGradosFiltro(id_nivel) {
      this.lista_filtro_grados = [];
      this.filtro.id_grado = null;
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_nivel: id_nivel
      };

      axios
        .post("/sistema/integral/getGradoAdm/", { filter: params })
        .then((response) => {
          this.lista_filtro_grados = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    // FORMULARIO
    getListaAnios() {
      this.lista_niveles = [];
      this.lista_grados = [];
      this.lista_secciones = [];
      this.lista_estudiantes = [];
      axios
        .get("/administrativo/anoLectivo/estado/" + this.dataSession.id_colegio)
        .then((response) => {
          this.lista_anios = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaNiveles(id_anio) {
      this.lista_niveles = [];
      this.lista_grados = [];
      this.lista_secciones = [];
      this.lista_estudiantes = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: id_anio,
      };

      axios
        .post("/tesoreria/common/nivel", params)
        .then((response) => {
          this.lista_niveles = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaGrados(id_nivel) {
      this.lista_grados = [];
      this.lista_secciones = [];
      this.lista_estudiantes = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_nivel: id_nivel
      };

      axios
        .post("/sistema/integral/getGradoAdm/", { filter: params })
        .then((response) => {
          this.lista_grados = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaSecciones(id_anio, id_nivel, id_grado) {
      console.log(id_anio, id_nivel, id_grado);
      this.lista_secciones = [];
      this.lista_estudiantes = [];
      const params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: id_anio,
        id_nivel: id_nivel,
        id_grado: id_grado
      };
      axios
        .post("/tesoreria/common/seccion", params)
        .then((response) => {
          this.lista_secciones = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaMonedas() {
      axios
        .get("/tesoreria/common/moneda")
        .then((response) => {
          this.lista_monedas = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaTurnos() {
      axios
        .get("/mantenimiento/turnos")
        .then((response) => {
          this.lista_turnos = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaEstudiantes(id_anio, id_seccion) {
      console.log('getListaEstudiantes');
      this.lista_estudiantes = [];
      const params = { id_colegio: this.dataSession.id_colegio, id_anio: id_anio, id_seccion: id_seccion };
      axios
        .post("/tesoreria/common/estudiante", params)
        .then((response) => {
          this.lista_estudiantes = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    async getListaAsigProvisions() {
      this.selectedItems = [];
      this.loading = true;
      this.filtro.id_colegio = this.dataSession.id_colegio;
      await axios
        .post("/tesoreria/asignacion/provision/consulta", this.filtro)
        .then((response) => {
          this.listItems = response.data;
          this.loading = false;
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
          this.loading = false;
        });
    },

    getAsigProvisionById(id) {
      axios
        .get("/tesoreria/asignacion/provision/" + id)
        .then((response) => {
          this.editedItem = response.data;
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
        });
    },

    getAsigProvisionDetalleByIdParent(id) {
      this.listItemsDetail = [];
      this.selectedItemDetails = [];
      this.loadingDetail = true;

      axios
        .get("/tesoreria/asignacion/provision/detalle/" + id)
        .then((response) => {
          this.listItemsDetail = response.data;
          this.listItemsDetail.forEach((x) => {
            if (x.elegido) {
              this.selectedItemDetails.push(x);
            }
          });
          this.loadingDetail = false;
          console.log(this.editedItem);
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
          this.loadingDetail = false;
        });
    },

    async saveItem(id = 0) {
      if (this.$refs.formDatos.validate()) {
        if (this.selectedItemDetails.length > 0) {
          this.btnIsSaving = true;
          try {
            this.editedItem.detalle = this.listItemsDetail.map(x => {
              x.elegido = this.selectedItemDetails.filter(a => a.id_mes == x.id_mes).length == 1 ? 1 : 0;
              return x;
            });
            const params = Object.assign({}, this.editedItem);
            params["user_id"] = this.dataSession.id;
            params["colegio_id"] = this.dataSession.id_colegio;
            if (this.isNew) {
              await axios.post("/tesoreria/asignacion/provision", params);
            } else {
              await axios.put("/tesoreria/asignacion/provision/" + id, params);
            }

            this.showDialog = false;
            this.setEnviarMens({ tipo: "S", mensaje: "¡Información creada con éxito!", tiempo: null });
            this.limpiarForm();
            this.getListaAsigProvisions();
          }
          catch (error) {
            this.btnIsSaving = false;
            this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          }
        } else {
          this.setEnviarMens({ tipo: "W", mensaje: `Selecciona al menos un mes`, tiempo: null });
        }
      }
    },


    async generateProvision(id) {
      try {
        this.generateItems
        const params = {
          id_asig_provision: id,
          user_id: this.dataSession.id,
          colegio_id: this.dataSession.id_colegio,
        };

        let response = await axios.post("/tesoreria/asignacion/provision/generate", params);
        if (response.data.error == 1) {
          this.setEnviarMens({ tipo: "E", mensaje: `${response.data.message}`, tiempo: null });
        }
        else {
          this.setEnviarMens({ tipo: "S", mensaje: `${response.data.message}`, tiempo: null });
          this.showDialog = false;
          this.cancelGenerate();
          this.getListaAsigProvisions();
        }
      }
      catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },


    async deleteItems() {
      try {
        const params = this.selectedItems.map(x => ({ id_asig_provision: x.id_asig_provision }));
        console.log(params);

        let response = await axios.post("/tesoreria/asignacion/provision/delete_batch", params);
        if (response.data.error == 1) {
          this.setEnviarMens({ tipo: "E", mensaje: `${response.data.message}`, tiempo: null });
          console.log(response);
        }
        else {
          this.setEnviarMens({ tipo: "S", mensaje: `${response.data.message}`, tiempo: null });
          this.showDialog = false;
          this.cancelDelete();
          this.getListaAsigProvisions();
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>